import React from 'react'
import { connect } from 'react-redux'
import {push} from "react-router-redux";
import l8n from 'l8n'
import EmailVerificationForm from "components/CustomComponents/Form/EmailVerificationForm";
import { getCurrentUser } from 'ducks/app'
import { sendVerificationEmail, verify, closePopup, openPopup } from 'ducks/email_verification'
import Modal from 'antd/lib/modal'
import Form from "antd/lib/form"
import message from 'antd/lib/message'
import linkit from 'scripts/linkit';

const mapStateToProps = (state, props) => ({
  user: getCurrentUser(state),
  isEmailSent: state.email_verification.emailConfirmationSent,
  isPopupOpen: state.email_verification.isPopupOpen,
})

const mapDispatchToProps = dispatch => ({
  sendConfirmationEmail: () => dispatch(sendVerificationEmail()),
  redirectToProfile: () => dispatch(push('/' + l8n.locale + '/settings')),
  verifyEmail: (formData) => dispatch(verify(formData)),
  openPopup: () => dispatch(openPopup()),
  closePopup: () => dispatch(closePopup()),
})

@connect(mapStateToProps, mapDispatchToProps)
@Form.create()
class EmailVerificationNotice extends React.Component {
  handleConfirmClick = async event => {
    event.preventDefault()
    const { isEmailSent, sendConfirmationEmail, openPopup } = this.props
    if (! isEmailSent) {
      sendConfirmationEmail()
      await message.loading(l8n['emailVerify.sending'], 2)
    }

    openPopup()
  }

  handleSubmit = (formData) => {
    const { verifyEmail } = this.props
    verifyEmail(formData)
  }

  openProfile = () => {
    this.props.closePopup()
    this.props.redirectToProfile()
  }

  render() {
    const { user, sendConfirmationEmail, isPopupOpen, closePopup } = this.props
    return (
      <React.Fragment>
        {linkit(l8n['emailVerify.warning.text'], [{
          href: '#',
          onClick: this.handleConfirmClick,
          className: 'utils__link--underlined',
          dataQaId: 'email-verify-link'
        }])}.
        <Modal
          visible={isPopupOpen}
          width={720}
          onCancel={closePopup}
          footer={null}
          wrapClassName="ant-modal-centered"
          destroyOnClose={true}
        >
          <EmailVerificationForm
            email={user.email}
            onProfile={this.openProfile}
            onSendCode={sendConfirmationEmail}
            onSubmit={this.handleSubmit}
          />
        </Modal>
      </React.Fragment>
    )
  }
}

export default EmailVerificationNotice



// WEBPACK FOOTER //
// ./src/components/CustomComponents/EmailVerificationNotice/index.js